
/**
 * Prospecting phase analysis utilities
 */

export function analyzeProspectingPhase(projectData: any, marketData: any): any {
  return {
    phaseSpecificMetrics: {
      landPackageSize: projectData.landArea || 0,
      geologicalPotential: calculateGeologicalPotential(projectData),
      accessibilityScore: assessAccessibility(projectData),
      permitStatus: projectData.permitStatus || 'pending'
    },
    riskProfile: {
      geologicalRisk: 85, // High for prospecting
      politicalRisk: 40,
      technicalRisk: 30,
      marketRisk: 60,
      overallRisk: 65
    },
    valueDrivers: [
      { name: 'Geological Prospectivity', weight: 40, score: 60 },
      { name: 'Location/Infrastructure', weight: 25, score: 50 },
      { name: 'Permit Security', weight: 20, score: 40 },
      { name: 'Market Timing', weight: 15, score: 70 }
    ],
    milestoneProjections: [
      {
        name: 'Initial Survey Completion',
        timeframe: '3-6 months',
        probability: 85,
        valueImpact: 15
      },
      {
        name: 'Target Definition',
        timeframe: '6-12 months',
        probability: 60,
        valueImpact: 30
      }
    ],
    fundingRequirements: {
      nextPhase: 250000,
      totalToProduction: 50000000,
      riskAdjustedNPV: -150000
    },
    probabilityOfSuccess: 25
  };
}

function calculateGeologicalPotential(projectData: any): number {
  return Math.min(100, (projectData.geologicalScore || 50) + Math.random() * 20);
}

function assessAccessibility(projectData: any): number {
  return Math.min(100, (projectData.accessibilityScore || 60) + Math.random() * 15);
}
